import React from 'react'
import { ErrorState } from './ErrorState'

type Props = {
  children: React.ReactNode
}

type State = {
  hayError: boolean
}

/**
 * Red de seguridad: si el render de una pagina lanza una excepcion, React
 * desmonta el arbol entero y el usuario se queda con la pantalla en blanco. Con
 * este limite se pinta un aviso y la aplicacion sigue en pie.
 */
export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hayError: false }

  static getDerivedStateFromError(): State {
    return { hayError: true }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // sin esto el fallo se pierde: se muestra el aviso y aqui queda el rastro
    console.error('Error no controlado en la aplicacion:', error, info)
  }

  render() {
    if (this.state.hayError) {
      return (
        <ErrorState
          title="Algo no ha ido bien"
          message="Ha ocurrido un error al cargar esta página. Vuelve a intentarlo o vuelve al inicio."
        />
      )
    }

    return this.props.children
  }
}
